import { useLocation } from 'react-router-dom';

function useExperienceAgendaId(): { experienceId?: string } {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  return {
    experienceId: searchParams.get('experienceId'),
  };
}

export default useExperienceAgendaId;
